(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifPopover', swifPopover)
    .directive('swifPopoverPanel', swifPopoverPanel);

    /**
    * @ngdoc directive
    * @name swif.ui:swifPopover
    * @module swif.ui
    * @restrict E
    * @description provide a popover from uib-bootstrap
    **/
    function swifPopover($compile, $templateCache, $q, $http) {
        'ngInject';
        var getTemplate = function(templateId) {
            var def = $q.defer();

            var template = '';
            template = $templateCache.get(templateId);
            if (typeof template === 'undefined') {
                $http.get(templateId).success(function(data) {
                    $templateCache.put('templateId.html', data);
                    def.resolve(data);
                });
            } else {
                def.resolve(template);
            }
            return def.promise;
        };
        return {
            restrict: 'A',
            scope: {
                swifPopover: '@',
                popoverPlacement: '@?',
                popoverAnimation: '=?',
                popoverPopupDelay: '=?',
                popoverTrigger: '=?',
                popoverAppendToBody: '=?'
            },
            link: function (scope, element) {
                var popOverContent;
                var html = getTemplate(scope.swifPopover);
                popOverContent = $compile(html)(scope.$parent);
                var options = {
                    content: popOverContent,
                    placement: scope.popoverPlacement || 'top',
                    animation: scope.popoverAnimation || true,
                    popupDelay: scope.popoverPopupDelay || 0,
                    html: true
                };
                $(element).popover(options);
            }
        };
    }
    /**
    * @ngdoc directive
    * @name swif.ui:swifPopoverPanel
    * @module swif.ui
    * @restrict E
    * @description provide a popover from uib-bootstrap
    * @usage
    *     <swif-popover-panel popover-placement="right" ng-model="user"><i class="fa fa-info"></i></swif-popover-panel>
    **/
    function swifPopoverPanel(swif) {
        'ngInject';
        var directive = {
            restrict: 'E',
            replace: false,
            require: 'ngModel',
            transclude: true,
            scope: {
                contentType: '@?',
                popoverTemplate: '@?',
                filter: '=?'
            }
        };
        directive.scope.popoverPlacement = '@?';
        directive.scope.popoverTrigger = '@?';
        directive.template = '' +
            '<a popover-trigger="{{popoverTrigger}}" ' +
            'popover-is-open="popover.opened" ' +
            'popover-append-to-body="false" ' +
            'uib-popover-template="popoverTemplate || \'partials/ui/swif_panel_proxy.html\'" ' +
            'popover-placement="{{popoverPlacement}}" ng-transclude>' +
            '</a>';
        directive.link = function (scope, element, attrs, ngModel) {
            element.addClass('swif-popover-panel');
            if (!scope.popoverTrigger) {
                scope.popoverTrigger = 'click';
            }
            if (scope.popoverTrigger === 'click') {
                element.find('a').addClass('link-trigger');
            } else {
                element.find('a').css('color', '#333');
            }
            if (!scope.popoverPlacement) {
                scope.popoverPlacement = 'top';
            }
            ngModel.$render = function () {
                var vv = ngModel.$viewValue;
                if (vv && _.isObject(vv)) {
                    if (vv._type) {
                        scope.proxy = vv;
                    }
                }
                scope.popover = {opened: false};
                if (vv && _.isNumber(vv)) {
                    //load it only on demand
                    element.bind(scope.popoverTrigger, function (event) {
                        if (scope.popoverTrigger === 'click') {
                            event.stopPropagation();
                        }

                        // Refresh data
                        swif.data.get(scope.contentType, vv, scope.filter).then(function(data){
                            scope.proxy = data;
                        });

                        scope.$apply();
                    });
                    if (scope.popoverTrigger === 'click') {
                        $('html').click(function() {
                            if (scope.popover.opened) {
                                scope.popover.opened = false;
                                scope.$apply();
                            }
                        });
                    }

                }
            };
            scope._ = _;
        };
        return directive;
    }

})();
